import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import theme from 'theme/theme';
import SubMenu from './SubMenu';
import {
  getActiveDepth,
  isOpen,
  getIsMenuOpenMobile,
  getActiveTrail,
} from '../../../store/ui/menu/selectors';
import { toggleSubmenu } from '../../../store/ui/menu/actions';
import { MenuIcon } from '../../components/Icon';

const MenuWrapper = styled.nav`
  position: absolute;
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  transition: 0.2s;
  transform: translateX(0%);
  overflow-x: hidden;
  z-index: 100;
  background: ${theme.colors.light};
  @media (min-width: ${theme.breakpoints.desktop}) {
    position: relative;
    border-right: 1px solid ${theme.colors.mediumLight};
    width: 110px;
    ${(props) => props.isOpen && css`
      width: 400px;
    `}
  }
  @media (max-width: ${theme.breakpoints.desktop}) {
    ${(props) => props.isOpenMobile && css`
      display: block;
    `}
    ${(props) => !props.isOpenMobile && css`
      display: none;
    `}
  }
`;
MenuWrapper.defaultProps = {
  isOpen: false,
};

const Toggle = styled.div`
  position: absolute;
  top: 80px;
  left: 100px;
  z-index: 101;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  width: 23px;
  height: 23px;
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.default};
  transition: 0.2s;
  ${(props) => props.isOpen && css`
    left: 388px;
  `};
  &:hover {
    cursor: pointer;
  }
  @media (max-width: ${theme.breakpoints.desktop}) {
    display: none;
  }
`;

// Only show toggle for menu items that have a submenu
// Hardcoded for now since this is unlikely to change and would require changes to the menu state
const showToggleFor = ['200', '400'];

const Menu = ({
  items,
  isOpen,
  isOpenMobile,
  activeDepth,
  activeTrail,
  ...props
}) => (
  <>
    {(showToggleFor.some((v) => activeTrail.includes(v))) && (
      <Toggle aria-label="toggle menu" onClick={props.toggle} isOpen={isOpen}>
        <MenuIcon style={{ marginTop: '3px' }} />
      </Toggle>
    )}
    <MenuWrapper isOpenMobile={isOpenMobile} isOpen={isOpen} {...props}>
      <div>
        <SubMenu
          items={items}
          isActive
        />
      </div>
    </MenuWrapper>
  </>

);
Menu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeDepth: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isOpenMobile: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  activeDepth: getActiveDepth(state),
  isOpen: isOpen(state),
  isOpenMobile: getIsMenuOpenMobile(state),
  activeTrail: getActiveTrail(state),
});

const mapDispatchToProps = {
  toggle: toggleSubmenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
